import { getField, updateField } from 'vuex-map-fields'
import { ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { PATH_ZR_JOB_OPENINGS } from '@/lib/constants/api'
import api from '@/lib/api'

const zohoIntegration = {
  namespaced: true,
  state: {
    jobOpenings: [
      {
        id: null,
        display_Name: null
      }
    ],
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    jobOpeningId: null,
    zRJobOpeningInfo: {}
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setJobOpenings: (state, jobOpenings) => {
      state.jobOpenings = jobOpenings
    },
    setJobOpeningInfo: (state, jobOpeningInfo) => {
      state.zRJobOpeningInfo = jobOpeningInfo
    }
  },
  actions: {
    getJobOpenings ({ state, commit, dispatch }) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting job openings from Zoho Recruit, please wait...' })

      return api.doGet({
        path: PATH_ZR_JOB_OPENINGS,
        parameters: { lastActivityTimeFilter: `${state.year}-${state.month}-1` }
      })
        .then(json => json.data)
        .then((jobOpenings) => {
          commit('setJobOpenings', jobOpenings)
        })
        .catch((error) => {
          notifyError(dispatch, 'Unable to get job openings.')
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getJobOpeningById ({ state, commit, dispatch }) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting job opening from Zoho Recruit, please wait...' })

      return api.doGet({
        path: PATH_ZR_JOB_OPENINGS,
        parameters: { jobOpeningId: state.jobOpeningId }
      })
        .then(json => json.data)
        .then((jobOpeningInfo) => {
          commit('setJobOpeningInfo', jobOpeningInfo)
        })
        .catch((error) => {
          notifyError(dispatch, 'Unable to get job opening.')
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default zohoIntegration
